import React from 'react'

const ApiContext = React.createContext()

ApiContext.displayName = `ApiContext`

export default ApiContext
